import React, {useState, useEffect} from 'react';
import "./UserSettingsCard.css";
import "./Card.css";
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function UserSettingsCard({app_user}) 
{
    const { setUserDisplayRefresh } = useCTAL();

    const [error, setError] = useState();
    const [form_changed_flag, setFormChangedFlag] = useState(false);
    const [update_user_settings_button_type, setUpdateUserSettingsButtonType] = useState("btn btn-sm btn-secondary mt-2");
    
    useEffect(() =>
    {
        if (DEBUG) console.log(`UserSettingsCard - form_changed_flag: ${form_changed_flag}`);
        if (!form_changed_flag)
            setUpdateUserSettingsButtonType("btn btn-sm btn-secondary mt-2");
        else
            setUpdateUserSettingsButtonType("btn btn-sm btn-primary mt-2");
    }, [form_changed_flag]);

    const send_user_settings_update = (body) => { 
        console.log(`UserSettingsCard - Send User Settings Update, body: ${body}`);
        //SSS-FUNC fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-upd`, { method: "POST", body: body })
        fetch(`https://cpcsaczyec.execute-api.us-east-1.amazonaws.com/ctal-func`, { method: "POST", body: body })
            .then(() => setUserDisplayRefresh(true))
            .catch(setError);
    }

    const create_user_settings_update = () => { 
        if (!app_user) return;
        if (!form_changed_flag) return;

        var type = "update_user_settings";
        var user_id    = app_user.UserID;
        var first_name = document.getElementById("user-settings-first-name").value;
        var middle_name = document.getElementById("user-settings-middle-name").value;
        var last_name = document.getElementById("user-settings-last-name").value;
        var mobile_country_prefix = document.getElementById("user-settings-mobile-num-country-prefix").value; //HERE TODO - set default value below
        var mobile_number = document.getElementById("user-settings-mobile-number").value;
        var email = document.getElementById("user-settings-email-address").value;
        var desc = document.getElementById("user-settings-description").value;
        var contact_pref = document.getElementById("user-settings-contact-pref").value;

        var body = JSON.stringify({type, user_id, first_name, middle_name, last_name, mobile_country_prefix, mobile_number, email, desc, contact_pref});

        send_user_settings_update(body);

        setFormChangedFlag(false);
    }
    
    const form_changed = () => { 
        setFormChangedFlag(true);
    }

    return (
        <div class="card mt-2">
            <div id="user-settings-card-header" class="card-header">
                <div class="row">
                    <div id="user-settings-title" class="col text-start">
                        <a href="#"><img class="card-icon" src="./images/settings.svg" alt="history" border="0"/></a>
                        <span className="card-sub-title">User Settings</span>
                    </div>
                </div>
            </div>
            <div class="card-body">

                <div class="input-group input-group-sm" required>
                        <span class="input-group-text" >First Name</span>
                        <input id="user-settings-first-name" type="text" class="form-control" placeholder="First Name" defaultValue={app_user.FirstName} aria-label="FirstName" aria-describedby="first-name" onChange={form_changed}/>
                </div>

                <div class="input-group input-group-sm mt-1" required>
                    <span class="input-group-text" >Middle Name</span>
                    <input id="user-settings-middle-name" type="text" class="form-control" placeholder="Middle Name" defaultValue={app_user.MiddleName} aria-label="MiddleName" aria-describedby="middle-name" onChange={form_changed}/>
                </div>
                
                <div class="input-group input-group-sm mt-1" required>
                    <span class="input-group-text" >Last Name</span>
                    <input id="user-settings-last-name" type="text" class="form-control" placeholder="Last Name" defaultValue={app_user.LastName} aria-label="LastName" aria-describedby="last-name" onChange={form_changed}/>
                </div>
                
                <div class="input-group input-group-sm mt-1" >
                    <span class="input-group-text" >Username</span>
                    <input id="user-settings-username" disabled type="text" class="form-control" placeholder="Application Username" defaultValue={app_user.UserName} aria-label="Username" aria-describedby="user-name"/>
                </div>
                
                <div class="input-group input-group-sm mt-1" required>
                    <span class="input-group-text" >Mobile # Country Prefix (ex. +1)</span>
                    <input id="user-settings-mobile-num-country-prefix" type="tel" class="form-control" placeholder="+1" defaultValue={app_user.PhoneCountry} aria-label="MobileNumberCountryPrefix" aria-describedby="mobile-number-country-prefix" onChange={form_changed}/>
                </div>
                
                <div class="input-group input-group-sm mt-1" required>
                    <span class="input-group-text" >Mobile #</span>
                    <input id="user-settings-mobile-number" type="tel" class="form-control" placeholder="Mobile Phone Number" defaultValue={app_user.MobilePhoneNumber} aria-label="MobileNumber" aria-describedby="mobile-number" onChange={form_changed}/>
                </div>

                <div class="input-group input-group-sm mt-1" required>
                    <span class="input-group-text" >Email</span>
                    <input id="user-settings-email-address" type="email" class="form-control" placeholder="Email Address" defaultValue={app_user.EmailAddress} aria-label="EmailAddress" aria-describedby="email-address" onChange={form_changed}/>
                </div>
                
                <div class="form-floating mt-1">
                    <textarea id="user-settings-description" class="form-control" placeholder="User Description" defaultValue={app_user.UserDescription} onChange={form_changed}></textarea>
                    <label class="select-floating-label" htmlFor="floatingSelect">User Description</label>
                </div>

                <div class="form-floating mt-1">
                    <select id="user-settings-contact-pref" class="form-select" defaultValue={app_user.ContactPref} aria-label="Contact Preference" onChange={form_changed}>
                        <option value="Email">Email</option>
                        <option value="SMS">SMS</option>
                    </select>
                    <label class="select-floating-label" htmlFor="floatingSelect">Contact Preference</label>
                </div>
                <div class="row">
                    <div class="col text-end">                      
                        <a href="#" class={update_user_settings_button_type} onClick={ () => create_user_settings_update() }>Update User Settings</a>
                    </div>
                </div>
            </div>
        </div>
    );
}

